import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { type FC } from "react"

import type { LandingPageBlock } from "@forento/core/models/landing"
import { blockDefinition } from "@forento/core/models/landingBlock"
import { cn } from "@forento/ui/utilities/tailwind"

import { DragIndicatorIcon } from "~/components/Icon"

type Props = {
	block: LandingPageBlock
	blockId: number
	index: number
	isReorderDisabled?: boolean
	onSelect(): void
}
const BlockOutlineItem: FC<Props> = ({ block, blockId, index, isReorderDisabled = false, onSelect }) => {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
		id: blockId,
		disabled: isReorderDisabled,
	})

	return (
		<div
			ref={setNodeRef}
			style={{
				transform: CSS.Transform.toString(transform),
				transition,
				zIndex: isDragging ? 20 : undefined,
			}}
			className="flex items-center gap-1.5 rounded-lg border-2 border-transparent bg-gray-50 px-2.5 py-2 text-sm transition-colors duration-200 ease-in-out hover:border-gray-200 hover:bg-gray-100"
		>
			<button
				type="button"
				disabled={isReorderDisabled}
				className={cn(
					"flex items-center justify-center rounded-md p-1 text-gray-400 transition-colors",
					isReorderDisabled
						? "cursor-auto opacity-40"
						: "cursor-grab touch-none hover:bg-white hover:text-gray-600 active:cursor-grabbing",
				)}
				aria-label={`Drag block ${index + 1}`}
				{...attributes}
				{...listeners}
			>
				<DragIndicatorIcon className="size-4" />
			</button>
			<button
				type="button"
				onClick={onSelect}
				className="min-w-0 flex-1 cursor-pointer truncate rounded-md px-1 py-0.5 text-left font-medium text-gray-600 transition-colors hover:text-gray-800"
			>
				{index + 1}. {blockDefinition(block.type).label}
			</button>
		</div>
	)
}

export default BlockOutlineItem
